import dompurify from 'dompurify';

/*
 * The DOMPurify-only half of `./text`. Error notifications render through these at boot, so they
 * live apart from `htmlToText`, whose `string-strip-html` and entity tables (~80 KB raw) would
 * otherwise ride along into the boot graph.
 */

/**
 * Converts a string to HTML and sanitizes it
 * @param text
 */
export function textToHtml(text: string | null | undefined) {
    if (typeof text !== 'string') return text || '';
    if (!text) {
        return '';
    }
    return dompurify.sanitize(text).replaceAll('\n', '<br/>');
}

/**
 * Sanitizes HTML
 * @param html
 */
export function sanitizeHtml(html: string | null | undefined) {
    if (typeof html !== 'string') return html || '';
    if (!html) {
        return '';
    }

    return dompurify.sanitize(html, { ALLOWED_ATTR: ['href', 'target'] });
}
